import type { StaffRegulator } from "../../queries/staff-regulators/types";

export const staffRegulatorDisplayName = (row: StaffRegulator): string => {
  const name = [row.given_name, row.family_name].filter(Boolean).join(" ");
  return name || row.email;
};

export const staffRegulatorMatchesSearch = (
  row: StaffRegulator,
  search: string,
): boolean => {
  if (!search.trim()) return true;
  const haystack =
    `${row.email} ${row.given_name ?? ""} ${row.family_name ?? ""}`.toLowerCase();
  return haystack.includes(search.trim().toLowerCase());
};

export const filterStaffRegulators = (
  items: StaffRegulator[],
  search: string,
  status: StaffRegulator["status"] | undefined,
): StaffRegulator[] =>
  items.filter(
    (row) =>
      staffRegulatorMatchesSearch(row, search) &&
      (status ? row.status === status : true),
  );

